(() => {
  const selector = '[data-ns-loop-carousel]';

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach((carousel) => {
      if (carousel.dataset.nsCarouselReady === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-ns-carousel-slide]:not([aria-hidden="true"])'));
      if (slides.length < 2) return;

      carousel.dataset.nsCarouselReady = 'true';
      let index = 0;
      let interval;
      let resetTimeout;
      let disabledByInteraction = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const stepWidth = () => {
        if (slides[1]) return slides[1].offsetLeft - slides[0].offsetLeft;
        return slides[0].getBoundingClientRect().width;
      };

      const stop = () => {
        disabledByInteraction = true;
        window.clearInterval(interval);
        window.clearTimeout(resetTimeout);
      };

      const reset = () => {
        carousel.classList.add('is-resetting');
        carousel.scrollTo({ left: 0, behavior: 'auto' });
        index = 0;
        window.requestAnimationFrame(() => carousel.classList.remove('is-resetting'));
      };

      const advance = () => {
        if (document.hidden || reducedMotion.matches || disabledByInteraction) return;
        index += 1;
        carousel.scrollTo({ left: index * stepWidth(), behavior: 'smooth' });

        if (index === slides.length) {
          resetTimeout = window.setTimeout(reset, 550);
        }
      };

      const start = () => {
        window.clearInterval(interval);
        if (!reducedMotion.matches && !disabledByInteraction) {
          interval = window.setInterval(advance, 5000);
        }
      };

      ['pointerdown', 'wheel', 'keydown'].forEach((eventName) => {
        carousel.addEventListener(eventName, stop, { passive: eventName !== 'keydown', once: true });
      });

      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) window.clearInterval(interval);
        else start();
      });

      window.addEventListener('resize', () => {
        window.clearTimeout(resetTimeout);
        reset();
      });

      start();
    });
  }

  if (window.NSLoopCarousel) {
    window.NSLoopCarousel.initialize(document);
    return;
  }

  window.NSLoopCarousel = { initialize };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
